import { useEffect } from 'react';
import { customListSchemaApi } from '../apis';
import { fetchSchemaFieldsSuccess } from './customListsReducer';
import useCustomLists from './useCustomLists';
import { useDispatch } from 'react-redux';
import { InternalApiCustomListSchemaField } from '../api-internal';

let requestPromise: Promise<{ customListId: string; schemaFields: InternalApiCustomListSchemaField[] }>[] | null = null;

const useSchemaFields = () => {
  const dispatch = useDispatch();
  const customLists = useCustomLists();

  useEffect(() => {
    if (!customLists.length || requestPromise !== null) {
      return;
    }

    requestPromise = customLists.map(async (customList) => {
      return {
        customListId: customList.id!,
        schemaFields: await customListSchemaApi
          .getCustomListSchema({
            customListId: customList.id!,
          })
          .then((result) => result.schemaFields),
      };
    });

    Promise.all(requestPromise)
      .then((fields) => dispatch(fetchSchemaFieldsSuccess(fields)))
      .finally(() => (requestPromise = null));
  }, [customLists.length]);
};

export default useSchemaFields;
